import React, { useEffect, useState } from "react";
import { GlobalContext } from "../../../../context";
import { TawreedTable, TawreedTableProps } from "../../../../common";
import { CssUtils } from "../../../../helpers/css";
import { tawreedTranslationService } from "../../../../common/translations";
import { PrimeIcons } from "primereact/api";
import { ColumnBodyOptions } from "primereact/column";
import { TawreedTableEditorCallback } from "../../../../common/components/table/editors";
import { Button } from "primereact/button";
import { PostUploadDialog } from "./post-upload-dialog";
import { SplitButton } from "primereact/splitbutton";
import { MenuItem } from "primereact/menuitem";
import { StoreProductDto } from "../../../catalog/store-products/domain";

export const PostExtraItemsTable: React.FC<any> = (props) => {
    const [state, setState] = useState<{
        visible: boolean,
        type?: 'IMAGE' | 'INTERNAL_LINK'
    }>({
        visible:false
    });
    const { constants: { constants } } = React.useContext(GlobalContext);
    // const [visible, setVisable] = useState<{ visable: boolean, data: Array<string>, title: string; }>
    //({ visable: false, data: [], title: "" });
    const bucketURL = process.env.REACT_APP_S3_BUCKET;
    const [menuItems, setMenuItems]= useState<MenuItem[]>([]);

    const downloadButton = (rowData: any, options: ColumnBodyOptions, callback: TawreedTableEditorCallback) => {


        return <React.Fragment>
        <Button
            style={{ width: "40%", height: "35px" }}
            icon={PrimeIcons.TRASH}
            className="p-button-danger ml-1"
            loading={props.loading}
            onClick={(e) => {
                props.delelteFile(rowData.fileId)
                e.preventDefault();
            }}
        >
        </Button></React.Fragment>
    }
    const hide = () => {
        setState({
            visible: false,
            type:undefined
        });
    }

    useEffect(() => {
        const items: MenuItem[] = [];

        items.push({
            label: "Image",
            icon: PrimeIcons.IMAGE,
            command: () => setState({
                visible: true,
                type:'IMAGE'
            }),
            disabled: props.data && props.data.filter((y:any)=>y.type ==="IMAGE").length>0 
        });
        items.push({
            label: "Link",
            icon: PrimeIcons.LINK,
            command: () => setState({
                visible: true,
                type:'INTERNAL_LINK'
            }),
            disabled: props.data && props.data.filter((y:any)=>y.type ==="INTERNAL_LINK").length>0 ,
        });
        setMenuItems(items);
    }, [props.data.length]);

    const accept = (data: { file?: File, titleEn: string, titleAr: string, type: string, subType?: string, storeProduct?: StoreProductDto }) => {
        
        props.addDocumentFile({
            file: data.file ? {
                fileName: data.file.name,
                value: data.file,
            }: undefined,
            titleEn: data.titleEn,
            titleAr: data.titleAr,
            type:data.type,
            subType: data.subType,
            storeProduct: data.storeProduct
        });
    }
    const tawreed: TawreedTableProps = {
        ds: {
            mode: 'basic',
            data: props.data ? props.data : [],
        },
        name: 'lbl_posts_images',
        outLoader: props.loading,
        dataKey: '',
        columns: [

            {
                field: "titleEn",
                header: "lbl_posts_images_titleEn",
                style: CssUtils.width('30%'),
                body: (options: any) => {
                    return (
                        <p>{options.titleEn}</p>
                    )
                },
            },
            
            {
                field: "titleAr",
                header: "lbl_posts_images_titleAr",
                style: CssUtils.width('30%'),
                body: (options: any) => {
                    return (
                        <p>{options.titleAr}</p>
                    )
                },
            },
            {
                field: "value",
                header: "",
                style: CssUtils.width('30%'),
                body: (options: any) => {
                    return (
                        <div className="text-center">
                            <img style={{maxHeight: '6rem', maxWidth:'100%' }}
                            src={
                                options.value ? options.value :
                                bucketURL + "\\" + (options.fileId)} alt={""} className="shadow-2" />
                        </div>
                    )
                },
            },
            {
                dataType: 'numeric',
                field: "download",
                style: CssUtils.width('10%'),
                body: downloadButton
            },
        ],
        header: {
            left: {
                search: false,
                custom: (
                    <span>
                        {tawreedTranslationService.translate(props.title)}
                    </span>
                )
            },
            right: {
                clear: false,
                custom: (
                    <div className="formgroup-inline">
                        <SplitButton buttonClassName="hidden" className="p-button-sm" label={""}  dropdownIcon={PrimeIcons.PLUS} menuButtonClassName={"p-button-text"} onClick={() => {}} disabled={props.loading} model={menuItems} />

                    </div>
                )
            }
        }
    };

    return (
        <React.Fragment>
            <div className="col-12 md:col-12"><TawreedTable {...tawreed} /></div>
            <PostUploadDialog
                visible={state.visible}
                type={state.type}
                hide={hide}
                storeId={props.storeId}
                accept={accept}
            />
        </React.Fragment>
    );
}
